/**
 * Utility functions for positioning a given dom element around an anchor dom element.
 * Positioning logic ported from Asimov Tooltip Jquery plugin.
 */

var locations = {
    'up-left': {'direction': 'up', 'alignment': 'left', 'coordinate': [-1, -2]},
    'up-center': {'direction': 'up', 'alignment': 'center', 'coordinate': [0, -2]},
    'up-right': {'direction': 'up', 'alignment': 'right', 'coordinate': [1, -2]},
    'down-left': {'direction': 'down', 'alignment': 'left', 'coordinate': [-1, 2]},
    'down-center': {'direction': 'down', 'alignment': 'center', 'coordinate': [0, 2]},
    'down-right': {'direction': 'down', 'alignment': 'right', 'coordinate': [1, 2]},
    'left-top': {'direction': 'left', 'alignment': 'top', 'coordinate': [-6, -1]},
    'left-middle': {'direction': 'left', 'alignment': 'middle', 'coordinate': [-6, 0]},
    'left-bottom': {'direction': 'left', 'alignment': 'bottom', 'coordinate': [-6, 1]},
    'right-top': {'direction': 'right', 'alignment': 'top', 'coordinate': [6, -1]},
    'right-middle': {'direction': 'right', 'alignment': 'middle', 'coordinate': [6, 0]},
    'right-bottom': {'direction': 'right', 'alignment': 'bottom', 'coordinate': [6, 1]},
    'up-fluid': {'direction': 'up', 'alignment': 'fluid', 'coordinate': [0, -15]},
    'down-fluid': {'direction': 'down', 'alignment': 'fluid', 'coordinate': [0, 15]}
};

function getDistanceSquared(locationNameA, locationNameB) {
    var locationA = locations[locationNameA];
    var locationB = locations[locationNameB];

    return Math.pow(locationA.coordinate[0] - locationB.coordinate[0], 2) +
        Math.pow(locationA.coordinate[1] - locationB.coordinate[1], 2);
}

function getPosition($anchorElement, $element, location, distance, alignmentOffset) {
    var anchorRect = $anchorElement[0] && $anchorElement[0].getBoundingClientRect();
    var elemRect = $element[0] && $element[0].getBoundingClientRect();
    var scrollTop = $(window).scrollTop();
    var position = {};

    if(!anchorRect || !elemRect){
        return position;
    }

    distance = distance || 0;
    alignmentOffset = alignmentOffset || 0;

    switch (location.direction) {
        case 'up':
            position.top = anchorRect.top + scrollTop - distance - elemRect.height;
            break;
        case 'down':
            position.top = anchorRect.top + scrollTop + distance + anchorRect.height;
            break;
        case 'left':
            position.left = anchorRect.left - distance - elemRect.width;
            break;
        case 'right':
            position.left = anchorRect.left + distance + anchorRect.width;
            break;
    }

    if (location.alignment !== 'fluid') {
        switch (location.alignment) {
            case 'left':
                position.left = anchorRect.left + alignmentOffset;
                break;
            case 'center':
                position.left = anchorRect.left + (anchorRect.width / 2) - (elemRect.width / 2);
                break;
            case 'right':
                position.left = anchorRect.left + anchorRect.width - elemRect.width - alignmentOffset;
                break;
            case 'top':
                position.top = anchorRect.top + scrollTop + alignmentOffset;
                break;
            case 'middle':
                position.top = anchorRect.top + scrollTop + (anchorRect.height / 2) - (elemRect.height / 2);
                break;
            case 'bottom':
                position.top = anchorRect.top + scrollTop + (anchorRect.height - elemRect.height) - alignmentOffset;
                break;
        }
    }

    return position;
}

function isOffPage($element) {
    var elemRect = $element[0] && $element[0].getBoundingClientRect();

    return elemRect && (elemRect.right > $(window).width() ||   // overflow right?
        elemRect.bottom > $(window).height() ||    // overflow bottom?
        elemRect.left < 0 ||                       // overflow left?
        elemRect.top < 0);                          // overflow top?
}

export function positionElement($element, $anchorElement, locationName, distance, alignmentOffset) {
    var location = locations[locationName];

    $element.css({'top': '', 'left': '', 'width': ''});

    // Setting to current width as wrapping occurs on right edge
    if (location.alignment !== 'fluid') {
        // Round up width up and add 1px to prevent edge case wrapping
        var width = $element[0] && Math.ceil($element[0].getBoundingClientRect().width) + 1;
        $element.css('width', width);
    }

    $element.css(getPosition($anchorElement, $element, location, distance, alignmentOffset));

    // Recalculate in case of wrapping
    if (location.direction === 'up') {
        $element.css(getPosition($anchorElement, $element, location, distance, alignmentOffset));
    }

    return locationName;
}

export function positionElementWithAutoAdjustment($element, $anchorElement, locationName, distance, alignmentOffset) {
    var orderedLocations = Object.keys(locations).sort(function (a, b) {
        return getDistanceSquared(a, locationName) - getDistanceSquared(b, locationName);
    });

    var finalLocationName = null;

    orderedLocations.every(function (locName) {
        positionElement($element, $anchorElement, locName, distance, alignmentOffset);
        finalLocationName = locName;
        return isOffPage($element);
    });

    return finalLocationName;
}

export function getPossiblePositions() {
    return Object.keys(locations);
}



// WEBPACK FOOTER //
// ./~/@99designs/react-components/lib/elementPosition.js